import { CompetenzeMeseAnnoFattureOutputDto } from '@api/client';
import { useAppDispatch } from 'core/store/hooks';
import { getCompetenzeMeseAnnoCicloAttivo } from 'pages/private/_redux/fatture/actions';
import React from 'react';
import { useEffect, useState } from 'react';
import { Modal, Table } from 'react-bootstrap';
import NoData from 'shared/design-system/components/no-data-box';
import { formatCurrency, getFormattedDateHeader, sortByMonthAndYear } from 'shared/utils/common.utils';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  idOrdine: number | undefined;
}

const ActiveOrderTotalInvoicesRecapModal: React.FC<Props> = ({ isOpen, onClose, idOrdine }) => {
  const dispatch = useAppDispatch();
  const [competences, setCompetences] = useState<CompetenzeMeseAnnoFattureOutputDto[] | undefined>([]);

  useEffect(() => {
    if (!idOrdine || !isOpen) return;
    dispatch(getCompetenzeMeseAnnoCicloAttivo(idOrdine))
      .unwrap()
      .then((res) => {
        if (res && res.length > 0) {
          const clone = [...res];
          setCompetences(sortByMonthAndYear(clone));
        }
      });
  }, [idOrdine, isOpen, dispatch]);

  const CompetencesTable: React.FC<{ competences: CompetenzeMeseAnnoFattureOutputDto[] | undefined }> = ({
    competences,
  }) => {
    const allMonths = Array.from(new Set(competences?.map(({ mese, anno }) => `${anno}-${mese}`)));

    return (
      <>
        {competences?.length === 0 && <NoData msg="No competences found for this order." />}
        {competences?.length && (
          <Table bordered>
            <thead>
              <tr>
                <th>Month</th>
                <th className="bg-disabled">Tot</th>
                {allMonths.map((key) => {
                  const [year, month] = key?.split('-') || [];
                  return (
                    <th key={`${key}-label`} className="text-center">
                      {getFormattedDateHeader(parseInt(month), parseInt(year))}
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Revenues</td>
                <td className="text-end bg-disabled">
                  {competences?.reduce((acc, c) => acc + (c.ricavi || 0), 0)
                    ? `${formatCurrency(competences.reduce((acc, c) => acc + (c.ricavi || 0), 0))}€`
                    : '-'}
                </td>
                {competences?.map((c) => (
                  <td key={`revenue_${c.mese}-${c.anno}`} className="text-end">
                    {c.ricavi ? `${formatCurrency(c.ricavi)}€` : '-'}
                  </td>
                ))}
              </tr>
              <tr>
                <td>Invoices</td>
                <td className="text-end bg-disabled">
                  {competences?.reduce((acc, c) => acc + (c.fatture || 0), 0)
                    ? `${formatCurrency(competences.reduce((acc, c) => acc + (c.fatture || 0), 0))}€`
                    : '-'}
                </td>
                {competences?.map((c) => (
                  <td key={`invoices_${c.mese}-${c.anno}`} className="text-end">
                    {c.fatture ? `${formatCurrency(c.fatture)}€` : '-'}
                  </td>
                ))}
              </tr>
              <tr>
                <td>Invoices Comp.</td>
                <td className="text-end bg-disabled">
                  {competences?.reduce((acc, c) => acc + (c.competenzaFatture || 0), 0)
                    ? `${formatCurrency(competences.reduce((acc, c) => acc + (c.competenzaFatture || 0), 0))}€`
                    : '-'}
                </td>
                {competences?.map((c) => (
                  <td key={`expense_${c.mese}-${c.anno}`} className="text-end">
                    {c.competenzaFatture ? `${formatCurrency(c.competenzaFatture)}€` : '-'}
                  </td>
                ))}
              </tr>
              <tr>
                <td>FdE</td>
                <td className="text-end bg-disabled">
                  {competences?.reduce((acc, c) => acc + (c.fde || 0), 0)
                    ? `${formatCurrency(competences.reduce((acc, c) => acc + (c.fde || 0), 0))}€`
                    : '-'}
                </td>
                {competences?.map((c) => (
                  <td key={`fde_${c.mese}-${c.anno}`} className="text-end">
                    {c.fde ? `${formatCurrency(c.fde)}€` : '-'}
                  </td>
                ))}
              </tr>
              <tr>
                <td>Expense</td>
                <td className="text-end bg-disabled">
                  {competences?.reduce((acc, c) => acc + (c.risconto || 0), 0)
                    ? `${formatCurrency(competences.reduce((acc, c) => acc + (c.risconto || 0), 0))}€`
                    : '-'}
                </td>
                {competences?.map((c) => (
                  <td key={`expense_${c.mese}-${c.anno}`} className="text-end">
                    {c.risconto ? `${formatCurrency(c.risconto)}€` : '-'}
                  </td>
                ))}
              </tr>
            </tbody>
          </Table>
        )}
      </>
    );
  };

  return (
    <Modal show={isOpen} onHide={onClose} size="xl">
      <Modal.Header closeButton>
        <Modal.Title>{`Invoices`}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ height: '50vh', maxHeight: '50vh', overflowY: 'auto' }}>
        <CompetencesTable competences={competences} />
      </Modal.Body>
    </Modal>
  );
};

export default ActiveOrderTotalInvoicesRecapModal;
